import styled from '@emotion/styled';
import { DRAWER_WIDTH, DRAWER_COLLAPSED_WIDTH, DRAWER_COLLAPSED_MOBILE_WIDTH } from '../SideBar/constants';

export const Layout = styled.div(() => ({
  display: 'grid',
  gridTemplateColumns: `${DRAWER_WIDTH}px 1fr`,
  height: '100vh',
  transition: 'grid-template-columns 300ms ease',
  '&.collapsed': {
    gridTemplateColumns: `${DRAWER_COLLAPSED_WIDTH}px 1fr`,
  },
  '@media screen and (max-width: 850px)': {
    '&.collapsed': {
      gridTemplateColumns: `${DRAWER_COLLAPSED_MOBILE_WIDTH}px 1fr`,
    },
  },
}));
